export const FETCH_FILE:string = 'FETCH_FILE';
export const FETCH_OFFER_PDF:string = 'FETCH_OFFER_PDF';
export const FILE_SUCCESS:string = 'FILE_SUCCESS';
export const FILE_ERROR:string = 'FILE_ERROR';
export const FILE_REMOVE:string = 'FILE_REMOVE';
export const FETCH_MDS_REPORT:string = 'FETCH_MDS_REPORT';
export const FETCH_VPN_OFFER_PDF:string = 'FETCH_VPN_OFFER_PDF';